import React from 'react';
import logoImage from "@/assets/logo.png";
import logoSvg from "@/assets/logo.svg";
import { useOnboardingConfig } from '@/hooks/useOnboardingConfig';

interface BrandLogoProps {
  className?: string;
  alt?: string;
  variant?: "header" | "auth" | "onboarding";
}

const BrandLogo = React.forwardRef<HTMLImageElement, BrandLogoProps>(({ 
  className = "h-8", 
  alt = "לוגו",
  variant = "header" 
}, ref) => {
  const { config } = useOnboardingConfig();
  
  const shouldUseSvg = config?.brandLogoSvg !== undefined ? Boolean(config.brandLogoSvg) : true;
  const logoSrc = shouldUseSvg ? logoSvg : logoImage;
  
  const headerBlendClass = variant === "header" && !shouldUseSvg ? "mix-blend-multiply opacity-95" : "";
  
  return (
    <img 
      ref={ref}
      src={logoSrc} 
      alt={alt} 
      className={`${className} ${headerBlendClass} object-contain w-auto pointer-events-none`}
      aria-label={alt}
    />
  );
});

BrandLogo.displayName = 'BrandLogo';

export default BrandLogo;
